<template>
  <div>
    <a-card 
      size="small" 
      title="查询"
      :headStyle='{
        background : "#f3f3f3"
      }'
      >
      <a-form layout="inline">
        <a-form-item>
          <!-- <a-input placeholder="商户筛选" v-model="searchForm.name" allowClear @keyup.enter.native="searchAction()"/> -->

          <df-selectChannelShop @setValue='searchAction()' :model='searchForm'></df-selectChannelShop>
        </a-form-item>
        <a-form-item>
          <a-range-picker 
            v-model:value='searchForm.date'
            :placeholder='["创建开始","创建结束"]'
            valueFormat='YYYY-MM-DD'
            format='YYYY-MM-DD'
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click='searchAction'>
            查询
          </a-button>

        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
      </a-form>
    </a-card> 
    <!-- <div class='card_ct'>
        <a-card style='width:200px;margin-top:20px'>
            <a-statistic
            title="全部账户资金"
            :value="9.3"
            :precision="2"
            class="demo-class"
            :value-style="{ color: '#cf1322' }"
            >
            <template #prefix>
                <my-icon type="iconziyuanldpi" style='margin-right:10px'/>
            </template>
            </a-statistic>
        </a-card>

        <a-card style='width:200px;margin-top:20px'>
            <a-statistic
            title="当月充值"
            :value="9.3"
            :precision="2"
            class="demo-class"
            :value-style="{ color: '#75f454' }"
            >
              <template #prefix>
                  <my-icon type="iconchongzhi" style='margin-right:10px'/>
              </template>
            </a-statistic>
        </a-card>

        <a-card style='width:200px;margin-top:20px'>
            <a-statistic
              title="当月使用资金"
              :value="9.3"
              :precision="2"
              class="demo-class"
              :value-style="{ color: '#4196d5' }"
            >
            <template #prefix>
                <my-icon type="iconzijin" style='margin-right:10px'/>
            </template>
            </a-statistic>
        </a-card>
    </div> -->
    <a-card 
      size="small" 
      title="资金列表"
      style='margin-top:20px'
      :headStyle='{
        background : "#f3f3f3"
      }'
      :bodyStyle='{
        padding : "0"
      }'
      >
      <template v-slot:extra>
        <a-button slot="extra"  @click="toAdd" type="primary">充值</a-button>
      </template>
      <a-table :columns="columns" bordered 
        :data-source="list" 
        :pagination='false' 
        :row-key="r => r.id"
        :loading='loading'
        >

        <template v-slot:creater="{ text,record }">
          {{record.creatorBo?record.creatorBo.username:''}}
        </template>

        <template v-slot:shop="{ text,record }">
          <span style='color:#1890ff;cursor: pointer;' @click='toShopDetail(record)'>{{record.supplierBo.name}}</span>
        </template>
        

        <template v-slot:operation="{ text,record }">
          <a-button type="primary" @click='toLook(record)'>
            查看详情
          </a-button>
        </template>
        

      </a-table>
    </a-card> 
    <a-modal
      title="充值信息"
      style="top: 20px;"
      v-model:visible="modalVisible"
      :footer="null"
      :width='1100'  

      >
        
        <div class='modal_ct'>
          
          <div>
            <a-row :gutter='24' class='ar'>
              <a-col :span="8" class='bgl'>
        
                  系统流水号：
                
              </a-col>
              <a-col :span="16" class='bgr'>
                {{orderDetail.flowCode}}
                
            
              </a-col>
            </a-row>
            <a-row :gutter='24' class='ar'>
              <a-col :span="8" class='bgl'>
        
                平台流水：
                
              </a-col>
              <a-col :span="16" class='bgr'>
                
                {{orderDetail.paymentCode}}
            
              </a-col>
            </a-row>
            <a-row :gutter='24' class='ar'>
              <a-col :span="8" class='bgl'>
        
                  充值金额：
                
              </a-col>
              <a-col :span="16" class='bgr'>
                  
                  {{orderDetail.amount}}（元）
            
              </a-col>
            </a-row>
            
            <a-row :gutter='24' class='ar'>
              <a-col :span="8" class='bgl'>
        
                  充值日期：
                
              </a-col>
              <a-col :span="16" class='bgr'>
                  
                  {{orderDetail.createTime}}
            
              </a-col>
            </a-row>
          
          </div>
          <div>
            <a-row :gutter='24' class='ar'>
              <a-col :span="8" class='bgl'>

                  充值商户：
                
              </a-col>
              <a-col :span="16" class='bgr'>
                  
                  {{orderDetail.supplierName}}
            
              </a-col>
            </a-row>
        
            <a-row :gutter='24' class='ar'>
              <a-col :span="8" class='bgl'>

                  充值平台：
                
              </a-col>
              <a-col :span="16" class='bgr'>
                 {{orderDetail.paymentTypeValue}}
                  
            
              </a-col>
            </a-row>
            <a-row :gutter='24' class='ar'>
              <a-col :span="8" class='bgl'>

                  充值业务：
                
              </a-col>
              <a-col :span="16" class='bgr'>
                 {{orderDetail.businessValue}}
                  
            
              </a-col>
            </a-row>
          </div>
        </div>
        <df-titleline :title="'充值凭证'"></df-titleline>
        <a-row>
          <!-- <viewer :images="fileList1"> -->
            <img v-for="(src,index) in orderDetail.paymentVoucher.split(',')" :src="baseuri + src" :key="index" class='viewer_img' @click='preview(src)'>
          <!-- </viewer> -->
        </a-row>
    </a-modal>


    <df-pagination :model='pageObj'></df-pagination>

    <a-modal v-model:visible="viewVisible" title="预览" width='800'>
        <!-- @ok="handleOk" -->
        <img :src="baseuri + prevImg" style="width:100%">
    </a-modal>

  </div>
</template>

<script>
  import shopApi from '@axios/shop'
  import { ref,provide } from 'vue'
  import { useRouter } from 'vue-router'
  import moneyApi from '@axios/money'

  export default {
    name: 'shop',
    setup(){
      const router = useRouter();

      let modalVisible = ref(false);
      let loading = ref(false);
      let searchForm = ref({
          supplierId : undefined,
          date : []
      })
      let searchParams = ref({
          supplierId : undefined,
          date : []
      })

      const stateList = [
        {
          name : '供应',
          val : 10
        },
        {
          name : '渠道',
          val : 20
        }
      ];

      let list = ref([]);

      const columns = [
          {
            title: '供应商户',
            dataIndex: 'flowCode',
            width: 100,
            align : 'center',
            slots: { customRender: 'shop' },
          },
          {
            title: '系统流水号',
            dataIndex: 'flowCode',
            width: 200,
            align : 'center',
        
          },
          {
            title: '支付平台流水号',
            dataIndex: 'paymentCode',
            width: 200,
            align : 'center',
         
          },
          {
            title: '充值人',
            dataIndex: 'taxpayerNum',
            width: 100,
            align : 'center',
            slots: { customRender: 'creater' },
          },
          {
            title: '变动金额（元）',
            dataIndex: 'amount',
            width: 120,
            align : 'center',
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            width: 150,
            align : 'center',
          },
          {
            title: '变动类型',
            dataIndex: 'changeTypeValue',
            width: 150,
            align : 'center',
          },
          {
            title: '业务',
            dataIndex: 'businessValue',
            width: 100,
            align : 'center',
          },
          // {
          //   title: '状态',
          //   dataIndex: 'businessValue',
          //   width: 100,
          //   align : 'center',
          // },

          {
            title: '操作',
            align : 'center',
            dataIndex: 'operation',
            key: 'operation',
            width: 100,
            slots: { customRender: 'operation' },
          },
          
      ];
      
      let pageObj = ref({
        page : 1,
        rows : 10,
        totle : 1
      });

      const pageChange = (page) =>{
        pageObj.value.page = page;
        getList();
      }

      const onShowSizeChange = (current,pageSize) =>{
        pageObj.value.page = 1;
        pageObj.value.rows = pageSize;
        getList();
      }

      const searchAction = () =>{
        searchParams.value.supplierId = searchForm.value.supplierId;
        searchParams.value.date = searchForm.value.date;

        pageObj.value = {
          page : 1,
          rows : 10,
          totle : 1
        }
        getList();
      }

      const getList = () =>{
          
          loading.value = true;
          let params = {
            supplierId : searchParams.value.supplierId,
            currentPage : pageObj.value.page,
            size : pageObj.value.rows
          }

          if(searchParams.value.date.length){
            params.startTime = searchParams.value.date[0]
            params.endTime = searchParams.value.date[1]
          }

          moneyApi.supplierMoney(params).then(res => {
            loading.value = false;
            if(!res) return;
            pageObj.value.totle = res.total;
            pageObj.value.page = res.currentPage;
      
            list.value = res.data;
          })
      }

      const reset = () =>{
          searchForm.value.supplierId = undefined
         
          searchForm.value.date = []
          searchAction()
      }

      let orderDetail = ref({})

      const toLook = (row) =>{
        let params = {
          id : row.rechargeApplyId
        }
        moneyApi.distributrMoneyDetail(params).then((res)=>{
          modalVisible.value = true;
          orderDetail.value = res;
          orderDetail.value.flowCode = row.flowCode
          orderDetail.value.supplierName = row.supplierBo.name
 
        })
       
      }

      const toAdd = () =>{
        router.push({
          name : 'shopAddMoney'
        })
      }


      let viewVisible = ref(false);
      let prevImg = ref('');
      const preview = (info) => {
          viewVisible.value = true;
          prevImg.value = info
      }

      const toShopDetail = (record) => {
          const newweb = router.resolve({name: 'addShopIndex', query: {
              id : record.supplierBo.id,
              type : 'look'
          }})
          window.open(newweb.href,'_blank')
      }



      provide('pageChange',pageChange);
      provide('onShowSizeChange',onShowSizeChange);

      getList();

      return {
        viewVisible,
        prevImg,
        preview,
        orderDetail,
        modalVisible,
        searchForm,
        searchParams,
        stateList,
        list,
        columns,
        pageObj,
        loading,
        searchAction,
        reset,
        toLook,
        toAdd,
        baseuri : process.env.VUE_APP_IMG_BASE,
        toShopDetail


      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .card_ct{
        display: flex;
        justify-content: flex-start;
        div{
            margin-right: 20px;
        }
    }
    .modal_ct{
      display: flex;
      justify-content: flex-start;
      &>div{
        width: 50%;
        &>.ar:first-child{
          border-top:1px solid #00a0e9!important;
        }
      }
     
      .bgl{
        background:rgba(0,160,233,.7);
        text-align: right;
        line-height: 40px;
      }
      .bgr{
        text-align: left;
        line-height: 40px;
        color:#000;
      }
      .ar{
        border:1px solid #00a0e9;
        border-top:none;
        color:#fff;
      }
    }

  .modal_ct /deep/ .ant-row{
      margin: 0!important;
  }

  .viewer_img{
    width: 100px;
    margin-right: 10px;
    border-radius: 3px;
    margin-bottom: 10px;
    cursor: pointer;
  }

</style>

